import React from 'react';
import PropTypes from 'prop-types';
import CSSModules from 'react-css-modules';
import {autobind} from 'core-decorators';
import classNames from 'classnames';

import styles from './faq.scss';

@CSSModules(styles, {allowMultiple: true})
class FaqItem extends React.Component {

  static propTypes = {
    index: PropTypes.number,
    groupIndex: PropTypes.number,
    faqItem: PropTypes.object.isRequired
  };

  constructor(props) {
    super(props);
    this.state = {
      isOpen: false
    };
  }

  @autobind
  toggleItem() {
    this.setState({isOpen: !this.state.isOpen});
  }

  render() {
    const {faqItem} = this.props;
    const className = classNames('faqItem', {isOpen: this.state.isOpen});

    return (
      <div styleName={className}>
        <div styleName="faqItemHeader" onMouseDown={this.toggleItem}>{faqItem.question}</div>
        <div styleName="faqItemContent">{faqItem.answer}</div>
      </div>
    );
  }
}


export default FaqItem;



// WEBPACK FOOTER //
// ./src/faq/FaqItem.js